import { ReactNode } from 'react';
import { WorkflowOrder, WorkflowTab } from '../../../Api/Orders/ordersApi';
import { WORKFLOW_TAB_ORDER } from '../../Pages/Orders/workflowTabs';

export interface WorkflowPipelineSummaryProps {
  ordersByTab: Record<WorkflowTab, WorkflowOrder[]>;
  totalCount: number;
  activeTab: number;
  onTabSelect: (index: number) => void;
  newRequestAction?: ReactNode;
}

const PIPELINE_LABELS: Record<WorkflowTab, string> = {
  submitted: 'Submitted',
  quoting_in_progress: 'Quoting In Progress',
  reviewing_approving_quotes: 'Reviewing & Approving',
  upstack_processing_order: 'Processing Order',
  hand_off_to_pm: 'Handed Off to PM'
};

const CARD_COLORS: Record<WorkflowTab, string> = {
  submitted: 'bg-[#F9E5D9]',
  quoting_in_progress: 'bg-[#FFE6BB]',
  reviewing_approving_quotes: 'bg-[#FFF4BB]',
  upstack_processing_order: 'bg-[#E5EDFF]',
  hand_off_to_pm: 'bg-[#EDF8C3]'
};

const percentage = (count: number, total: number): string => {
  if (total === 0) return '0%';
  return `${Math.round((count / total) * 100)}%`;
};

export const WorkflowPipelineSummary = ({
  ordersByTab,
  totalCount,
  activeTab,
  onTabSelect,
  newRequestAction
}: WorkflowPipelineSummaryProps) => {
  return (
    <div
      className="flex items-center gap-4 rounded-lg bg-[#2C2C3A] px-5 py-4 mb-4"
      data-testid="pipeline-summary">
      {WORKFLOW_TAB_ORDER.map((tab, idx) => {
        const count = ordersByTab[tab].length;
        const pct = percentage(count, totalCount);
        const isActive = activeTab === idx;

        return (
          <button
            type="button"
            key={tab}
            data-testid={`pipeline-card-${tab}`}
            data-cy={`pipeline-card-${tab}`}
            aria-pressed={isActive}
            onClick={() => onTabSelect(idx)}
            className={[
              'flex items-center gap-3 flex-1 rounded-md px-3 py-2 text-left cursor-pointer transition-colors',
              isActive ? 'bg-[#3D3D4D]' : 'hover:bg-[#3D3D4D]'
            ].join(' ')}>
            <div
              className={
                `${CARD_COLORS[tab]} rounded-md w-10 h-10 flex items-center justify-center` +
                ' text-lg font-bold text-[#2C2C3A]'
              }>
              {count}
            </div>
            <div>
              <div className="text-sm text-white font-medium leading-tight">{PIPELINE_LABELS[tab]}</div>
              <div className="text-xs text-grey-4">{pct} of total</div>
            </div>
          </button>
        );
      })}
      {newRequestAction && (
        <div
          className="flex items-center ml-2"
          data-testid="pipeline-new-request">
          {newRequestAction}
        </div>
      )}
    </div>
  );
};
